export const roadmapTranslations = {
    posterTemplateInfo: {
        title: { vi: "Tuyển dụng lao động Bangladesh", bn: "হ্যালোজব বাংলাদেশ" },
        subtitle: { vi: "Tổng đại lý cung ứng nhân lực", bn: "১ম শ্রেণীর প্রধান অংশীদার" },
        headline: { vi: "Tuyển dụng lao động\nkỹ thuật Bangladesh", bn: "ভিয়েতনামে\nনিশ্চিত ক্যারিয়ার গড়ুন" },
        roadmapTitle: { vi: "5 Bước Tuyển Dụng cùng HelloJob", bn: "হ্যালোজবের ৫ ধাপের রোডম্যাপ" },
        step1: { vi: "Đăng ký tài khoản doanh nghiệp", bn: "নিবন্ধন এবং ডিজিটাল প্রোফাইল তৈরি" },
        step2: { vi: "Đăng tải nhu cầu tuyển dụng", bn: "বিশ্বস্ত অংশীদারের সাথে সংযোগ করুন" },
        step3: { vi: "Phỏng vấn trực tuyến qua Zoom", bn: "হাজার হাজার চাকরির সুযোগে এক্সেস" },
        step4: { vi: "Hoàn thiện Visa & Pháp lý", bn: "সরাসরি ভিডিও কলে ইন্টারভিউ দিন" },
        step5: { vi: "Tiếp nhận & Quản lý lao động", bn: "নিরাপদ প্রস্থান এবং কাজে যোগদান" },
        qrHeader: { vi: "Quét QR để Đăng ký ngay!", bn: "QR কোড স্ক্যান করে নতুন দরজা খুলুন!" },
        qrDesc: { vi: "Mở ứng dụng Camera thao tác cực tiết kiệm thời gian", bn: "অ্যাপ ডাউনলোড করতে ক্যামেরা দিয়ে স্ক্যান করুন" },
        agencyCodeLabel: { vi: "MÃ THEO DÕI", bn: "রেফারেল কোড (অংশীদার)" },
        darkMode: { vi: "Nền tối", bn: "ডার্ক মোড", en: "Dark Mode" },
        lightMode: { vi: "Nền sáng", bn: "লাইট মোড", en: "Light Mode" },
        selectBackground: { vi: "Chọn màu nền", bn: "ব্যাকগ্রাউন্ড কালার নির্বাচন করুন" }
    },
    hero: {
        badge: {
            vi: "Giải Pháp Nhân Sự Toàn Diện",
            bn: "হ্যালোজবে আপনাকে স্বাগতম"
        },
        titlePrefix: {
            vi: "Quy trình Tuyển dụng",
            bn: "স্বচ্ছ রোডম্যাপ"
        },
        titleSuffix: {
            vi: "Lao động Bangladesh",
            bn: "ভিয়েতনামে কাজ করার জন্য"
        },
        description: {
            vi: "HelloJob cung cấp giải pháp tuyển dụng toàn diện, giúp doanh nghiệp giải quyết bài toán thiếu hụt nhân sự tay nghề cao và tối ưu hóa chi phí vận hành.",
            bn: "আমরা আপনার সমস্যার কথা বুঝি। হ্যালোজব তৈরি করা হয়েছে সকল বাধা দূর করে ভিয়েতনামে আপনার একটি মজবুত নতুন পথ শুরু করতে সাহায্য করার cho bạn"
        },
        descriptionDesktop: {
            vi: "HelloJob mang đến giải pháp tuyển dụng nhân sự toàn diện và chuyên nghiệp, giúp doanh nghiệp giải quyết triệt để bài toán thiếu hụt nguồn lao động tay nghề cao từ Bangladesh, đồng thời tối ưu hóa quy trình vận hành và tiết kiệm chi phí doanh nghiệp một cách hiệu quả nhất.",
            bn: "হ্যালোজব বাংলাদেশ থেকে দক্ষ জনশক্তি নিয়োগের একটি পেশাদার এবং স্বচ্ছ প্রক্রিয়া নিশ্চিত করে। এটি আপনার ব্যবসার উৎপাদনশীলতা বৃদ্ধি করবে এবং নিয়োগ সংক্রান্ত দীর্ঘমেয়াদী জটিলতা দূর করে ব্যয় সাশ্রয় করতে সরাসরি সাহায্য করবে।"
        },
        ctaRegister: {
            vi: "Đăng ký Doanh nghiệp",
            bn: "এখনই নিবন্ধন করুন"
        },
        ctaProcess: {
            vi: "Tìm hiểu quy trình",
            bn: "প্রক্রিয়াটি জানুন"
        }
    },
    painPoints: {
        item1: {
            title: {
                vi: "Nguồn Lực Hạn Chế",
                bn: "স্বচ্ছতার অভাব"
            },
            description: {
                vi: "Khó tìm kiếm lao động tay nghề cao theo đúng yêu cầu sản xuất nội địa.",
                bn: "অনেক প্রার্থী ভুয়া চাকরির তথ্য বা অবাস্তব বেতনের মাধ্যমে প্রতারিত হন।"
            }
        },
        item2: {
            title: {
                vi: "Chi Phí Tuyển Dụng Cao",
                bn: "মধ্যস্থতাকারী খরচ"
            },
            description: {
                vi: "Tuyển dụng qua nhiều khâu môi giới làm tăng gánh nặng tài chính lâu dài.",
                bn: "ঐতিহ্যগত 'দালাল' ব্যবস্থা কর্মীদের ওপর আর্থিক বোঝা বাড়িয়ে দেয়।"
            }
        },
        item3: {
            title: {
                vi: "Rủi Ro Pháp Lý",
                bn: "নথি হারিয়ে যাওয়া"
            },
            description: {
                vi: "Khó khăn trong thủ tục xin cấp visa, quản lý ngôn ngữ và hồ sơ ngoại kiều.",
                bn: "পেশাদার নথি ব্যবস্থাপনা সিস্টেম না থাকায় আপনার সুযোগগুলো হাতছাড়া হয়ে যায়।"
            }
        }
    },
    solutions: {
        title: {
            vi: "Giải pháp của HelloJob",
            bn: "হ্যালোজবের সমাধান"
        },
        subtitle: {
            vi: "Tối Ưu – Nhanh Chóng – Toàn Diện",
            bn: "স্বচ্ছতা এবং পেশাদারিত্বের প্রতিশ্রুতি"
        },
        items: [
            {
                vi: "Cơ sở dữ liệu khổng lồ với hồ sơ ứng viên (E-CV) đã qua kiểm duyệt chuyên sâu.",
                bn: "এআই সমন্বিত পেশাদার ডিজিটাল প্রোফাইল (E-CV)।"
            },
            {
                vi: "Đánh giá trực quan năng lực qua hệ thống Video Profiles thực tế 100%.",
                bn: "বাস্তব ভিডিওর মাধ্যমে প্রার্থীর তথ্য ব্যবস্থাপনা।"
            },
            {
                vi: "Kết nối trực tiếp không qua trung gian giúp doanh nghiệp tối ưu chi phí hiệu quả.",
                bn: "ভিয়েতনামের ৫০০টিরও বেশি কোম্পানি ও ফ্যাক্টরির সাথে সরাসরি সংযোগ।"
            },
            {
                vi: "Hỗ trợ trọn gói thủ tục Visa trọn gói theo đúng pháp luật hai nước Việt Nam – Bangladesh.",
                bn: "আইনিভাবে স্বীকৃত এবং বিশ্বস্ত এজেন্ট নেটওয়ার্ক।"
            }
        ]
    },
    process: {
        title: {
            vi: "Quy trình Tuyển dụng 5 Bước",
            bn: "৫ ধাপের বিস্তারিত প্রক্রিয়া"
        },
        description: {
            vi: "HelloJob đồng hành cùng doanh nghiệp từ lúc bắt đầu đăng tuyển đến khi tiếp nhận và quản lý lao động.",
            bn: "শুরু থেকে ভিয়েতনামে আপনার জীবন স্থিতিশীল হওয়া পর্যন্ত আমরা আপনার পাশে আছি।"
        },
        steps: [
            {
                title: {
                    vi: "1. Đăng ký tài khoản",
                    bn: "১. অ্যাকাউন্ট তৈরি করুন"
                },
                description: {
                    vi: "Doanh nghiệp đăng ký tài khoản HelloJob nhanh chóng, hoàn toàn miễn phí. Khai báo thông tin công ty và lĩnh vực sản xuất để hệ thống chuẩn bị dữ liệu ứng viên phù hợp.",
                    bn: "হ্যালোজবে একটি অ্যাকাউন্ট নিবন্ধনের মাধ্যমে আপনার যাত্রা শুরু করুন। মৌলিক তথ্য পূরণ এবং যাচাই করতে মাত্র ৩০ সেকেন্ড সময় লাগে। এটি ভিয়েতনামে হাজার হাজার চাকরির সুযোগ পাওয়ার চাবিকাঠি।"
                },
                stageLabel: {
                    vi: "Giai đoạn 1",
                    bn: "পর্যায় ১"
                }
            },
            {
                title: {
                    vi: "2. Đăng tải nhu cầu tuyển dụng",
                    bn: "২. অংশীদারের সাথে নিবন্ধন করুন"
                },
                description: {
                    vi: "Đăng tin tuyển dụng với yêu cầu chi tiết về ngành nghề, số lượng, kỹ năng và mức lương. Hệ thống AI tự động phân tích và chủ động gợi ý danh sách ứng viên chất lượng nhất.",
                    bn: "বাংলাদেশে হ্যালোজব দ্বারা যাচাইকৃত সবচেয়ে বিশ্বস্ত এজেন্টদের (ম্যানপাওয়ার কোম্পানি) সাথে যুক্ত হোন। তারা আপনাকে প্রসেসিং, প্রশিক্ষণ এবং ক্যারিয়ার নির্দেশনায় সরাসরি সহায়তা করবে।"
                },
                stageLabel: {
                    vi: "Giai đoạn 2",
                    bn: "পর্যায় ২"
                }
            },
            {
                title: {
                    vi: "3. Phỏng vấn qua Video & Zoom",
                    bn: "৩. প্রোফাইল সম্পূর্ণ করুন (E-CV)"
                },
                description: {
                    vi: "Đánh giá chi tiết kỹ năng của ứng viên thông qua thư viện CV thực tế kết hợp Video ngắn. Doanh nghiệp tổ chức phỏng vấn trực tuyến thông qua Zoom được tích hợp sẵn ngay trong nền tảng.",
                    bn: "আপনার ব্যক্তিগত তথ্য, শিক্ষা এবং অভিজ্ঞতা পূরণের জন্য আমাদের এআই প্রোফাইল তৈরির টুল ব্যবহার করুন। একটি পেশাদার এবং পূর্ণাঙ্গ E-CV আপনাকে ভিয়েতনামী নিয়োগকর্তাদের কাছে আকর্ষণীয় করে তুলবে।"
                },
                stageLabel: {
                    vi: "Giai đoạn 3",
                    bn: "পর্যায় ৩"
                }
            },
            {
                title: {
                    vi: "4. Thủ tục Visa & Pháp lý",
                    bn: "৪. মিডিয়া আপলোড করুন"
                },
                description: {
                    vi: "Hệ thống hỗ trợ toàn bộ thủ tục cấp quyền, phê duyệt hợp đồng, đăng ký visa lao động và các giấy phép cần thiết, đảm bảo quy trình tuân thủ 100% quy định luật pháp Việt Nam – Bangladesh.",
                    bn: "বাস্তব ছবি এবং ভিডিও আপনার দক্ষতার সেরা প্রমাণ। আপনার পোর্ট্রেট ছবি, ইংরেজি বা ভিয়েতনামী ভাষায় আত্ম-পরিচয় ভিডিও এবং কাজের দক্ষতার ভিডিও (যেমন: ওয়েল্ডিং, কনস্ট্রাকশন ইত্যাদি) আপলোড করুন।"
                },
                stageLabel: {
                    vi: "Giai đoạn 4",
                    bn: "পর্যায় ৪"
                }
            },
            {
                title: {
                    vi: "5. Tiếp nhận & Quản lý lâu dài",
                    bn: "৫. নির্বাচিত হোন"
                },
                description: {
                    vi: "Tiếp nhận lao động có chứng nhận uy tín tới làm việc tận nơi, quản lý hợp đồng lao động điện tử (e-Contracts), chấm công và theo dõi chất lượng năng suất dễ dàng qua phần mềm.",
                    bn: "প্রোফাইল সম্পূর্ণ হওয়ার পর, এআই সিস্টেম আপনাকে উপযুক্ত চাকরির সাথে যুক্ত করবে। আপনি অনলাইন বা সরাসরি সাক্ষাৎকারে অংশ নেবেন এবং ভিয়েতনামের ফ্যাক্টরি বা কোম্পানি থেকে নিয়োগপত্র পাবেন।"
                },
                stageLabel: {
                    vi: "Giai đoạn 5",
                    bn: "পর্যায় ৫"
                }
            }
        ],
        ctaAction: {
            vi: "Đăng ký ngay",
            bn: "এখনই নিবন্ধন করুন"
        }
    },
    finalCta: {
        title: {
            vi: "Sẵn sàng tối ưu hóa nguồn nhân lực?",
            bn: "আপনি কি আপনার ভবিষ্যৎ পরিবর্তনের জন্য প্রস্তুত?"
        },
        description: {
            vi: "Hàng ngàn lao động tay nghề cao từ Bangladesh luôn sẵn sàng làm việc tại doanh nghiệp của bạn. Bắt đầu chiến dịch tuyển dụng ngay hôm nay!",
            bn: "সুযোগটি হাতছাড়া হতে দেবেন না। ভিয়েতনাম বাংলাদেশ থেকে মেধাবী জনশক্তিকে স্বাগত জানাতে অপেক্ষা করছে। আজই শুরু করুন!"
        },
        button: {
            vi: "Đăng ký Tuyển dụng Miễn phí",
            bn: "বিনামূল্যে প্রার্থী হিসেবে প্রোফাইল তৈরি করুন"
        },
        trustLabel: {
            vi: "Trusted and Secure Platform",
            bn: "বিশ্বস্ত এবং নিরাপদ প্ল্যাটফর্ম"
        }
    },
    referralCard: {
        title: {
            vi: "🤝 Giới thiệu bởi Tổng đại lý",
            bn: "🤝 কৌশলগত অংশীদারের দ্বারা আমন্ত্রিত"
        },
        codeLabel: {
            vi: "Mã đại lý:",
            bn: "অংশীদার কোড:"
        },
        qrInstruction: {
            vi: "Sử dụng Camera để quét và tiếp tục trên điện thoại",
            bn: "ফোনে চালিয়ে যেতে ক্যামেরা দিয়ে স্ক্যান করুন"
        },
        registerAction: {
            vi: "Bắt đầu đăng ký",
            bn: "নিবন্ধন শুরু করুন"
        },
        partnerStrategic: {
            vi: "Đối tác chiến lược của HelloJob",
            bn: "হ্যালোজবের chiến lược অংশীদার"
        },
        partnerDevelopment: {
            vi: "Đối tác phát triển của HelloJob",
            bn: "হ্যালোজবের উন্নয়ন অংশীদার"
        },
        titleMaster: {
            vi: "🤝 Giới thiệu bởi Tổng đại lý - Đối tác chiến lược của HelloJob",
            bn: "🤝 ১ম শ্রেণীর প্রধান অংশীদার - হ্যালোজবের কৌশলগত অংশীদার"
        },
        titleAgent: {
            vi: "🤝 Giới thiệu bởi Đại lý cấp 1 - Đối tác phát triển của HelloJob",
            bn: "🤝 ১ম শ্রেণীর অংশীদার - হ্যালোজবের উন্নয়ন অংশীদার"
        },
        codeLabelMaster: {
            vi: "Mã Tổng đại lý:",
            bn: "প্রধান অংশীদার কোড:"
        },
        codeLabelAgent: {
            vi: "Mã đại lý:",
            bn: "অংশীদার কোড:"
        }
    },
    referralConfirmation: {
        title: {
            vi: "Xác nhận Người giới thiệu",
            bn: "রেফারেল নিশ্চিত করুন"
        },
        description: {
            vi: "Bạn có muốn xác nhận được giới thiệu bởi Tổng đại lý [COMPANY] không? Việc này giúp chúng tôi hỗ trợ bạn tốt hơn.",
            bn: "আপনি কি কৌশলগত অংশীদার [COMPANY] দ্বারা আমন্ত্রিত হওয়া নিশ্চিত করতে চান? এটি আমাদের আপনাকে আরও ভালভাবে সহায়তা করতে সাহায্য করবে।"
        },
        confirm: {
            vi: "Xác nhận",
            bn: "নিশ্চিত করুন"
        },
        cancel: {
            vi: "Để sau",
            bn: "পরে"
        },
        toastSuccess: {
            vi: "Đã xác nhận người giới thiệu thành công!",
            bn: "রেফারেল সফলভাবে নিশ্চিত করা হয়েছে!"
        }
    }
};
